import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettingsService } from './app-settings.service';
import { IUserInfoModel } from './helpdesk.typings';
import { HttpService, IRequestOptions } from './http.service';

export interface ClaimModel {
  claimType: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  constructor(private http: HttpService, private appSettings: AppSettingsService) {}

  public getUsersByMcGroup = (mcGroups: string[]): Observable<IUserInfoModel[]> => {
    const options = {
      params: { mobiControlGroups: mcGroups },
    } as IRequestOptions;
    return this.http.get<IUserInfoModel[]>(this.appSettings.userInfoServiceUrl + 'groups/mobicontrol', options);
  };

  public getUserInfo = (
    userName: string,
    domain: string,
    address: string,
    name: string
  ): Observable<IUserInfoModel> => {
    const options = {
      params: {},
    } as IRequestOptions;

    if (userName) {
      options.params['userName'] = userName;
    }

    if (domain) {
      options.params['domain'] = domain;
    }

    if (address) {
      options.params['address'] = address;
    }

    if (name) {
      options.params['name'] = name;
    }

    return this.http.get<IUserInfoModel>(this.appSettings.userInfoServiceUrl , options);
  };

  public getUserInfoList(userInfoIds: string[]): Observable<IUserInfoModel[]> {
    const options = {
      params: { includePublicIds: userInfoIds.toString() },
    } as IRequestOptions;
    return this.http.get<IUserInfoModel[]>(this.appSettings.userInfoServiceUrl + 'search', options);
  }

  public searchUsers(params: HttpParams | { [param: string]: string | string[] }): Observable<IUserInfoModel[]> {
    const options = {
      params: params,
    } as IRequestOptions;

    return this.http.get<IUserInfoModel[]>(this.appSettings.userInfoServiceUrl + 'search', options);
  }

  public getCurrentUser(): Observable<IUserInfoModel> {
    return this.http.get<IUserInfoModel>(this.appSettings.userInfoServiceUrl + 'current');
  }

  /** @see IUserInfoService.getUserInfoSearchResource */

  public getUserInfoSearch(searchParams: any): Observable<IUserInfoModel[]> {
    const options = {
      params: searchParams,
    } as IRequestOptions;
    return this.http.get<IUserInfoModel[]>(this.appSettings.userInfoServiceUrl + 'search', options);
  }

  public getCurrentUserClaims(): Observable<ClaimModel[]> {
    return this.http.get<ClaimModel[]>(this.appSettings.userInfoServiceUrl + 'current/claims');
  }
}
